<template>
        <v-card v-if="dialog">
            <v-toolbar dark color="primary">
                <v-btn icon dark :disabled="loading" @click="cancel">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>

                <v-toolbar-title>{{title}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-layout wrap class="dialog-content">
                <v-flex xs12>
                    <v-data-table
                        v-if="teamRosterItems.length > 0"
                        :headers="headers"
                        :items="teamRosterItems"
                        class="elevation-1"
                        :pagination.sync="pagination"
                        hide-actions
                    >
                    <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.item.LocationName }}</td>
                        <td class="text-xs-center">{{ props.item.VarietyName }}</td>
                        <td class="text-xs-center">{{ props.item.TeamName }}</td>
                        <td class="text-xs-center" @click="openTeamEdit(props.index)" @focus="openTeamEdit(props.index)" :tabindex="0"
                            :ref="'t'+props.index">
                            <div v-if="isTeamEditing(props.index)">
                                <EditTableCell   
                                :value="props.item.Volume == null ? '' : props.item.Volume.toString()"
                                @input="modifyTeamRosterValue(props.index, props.item, $event)"
                                @close="closeTeamEdit(props.index, $event)"
                                :rules="[validateRosterValue]"
                                :suffix="uom"
                                :loading="teamLoading.indexOf(props.index) >= 0"></EditTableCell>
                            </div>
                            <div v-else class="small-cell font-weight-bold">
                                <span v-if="props.item.Volume != null">{{ props.item.Volume }}{{uom}}</span>
                                <span v-else>N/A</span>
                            </div>
                        </td>
                        </template>
                    </v-data-table>
                    <v-data-table
                        :headers="varietyHeaders"
                        :items="varietyRosterItems"
                        class="elevation-1"
                        hide-actions>
                    <template  v-slot:items="props">
                        <td></td>
                        <td class="text-xs-center">{{props.item.VarietyName}}</td>
                        <td></td>
                        <td class="text-xs-center" @click="openVarietyEdit(props.index)" @focus="openVarietyEdit(props.index)" :tabindex="0" 
                        :ref="'v'+props.index">
                            <div v-if="isVarietyEditing(props.index)">
                                <EditTableCell   
                                :value="props.item.Volume == null ? '' : props.item.Volume.toString()"
                                @input="modifyVarietyRosterValue(props.index, props.item, $event)"
                                @close="closeVarietyEdit(props.index, $event)"
                                :rules="[validateRosterValue]"
                                :suffix="uom"
                                :loading="varietyLoading.indexOf(props.index) >= 0"></EditTableCell>
                            </div>
                            <div v-else class="small-cell font-weight-bold">
                                <span v-if="props.item.Volume != null">{{ props.item.Volume }}{{uom}}</span>
                                <span v-else>N/A</span>
                            </div>
                        </td>
                    </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="save" ref="saveButton" :loading="loading" color="primary" :disabled="loading || teamEditMode.length > 0" :tabindex="0">Save</v-btn>
                <v-btn @click="cancel" :disabled="loading || teamEditMode.length > 0" color="error" :tabindex="0">Cancel</v-btn>
            </v-card-actions>
        </v-card>
</template>

<script>
import EditTableCell from '@/components/berriesRoster/EditTableCell.vue'
import RosterUtilService from '@/services/rosterUtilService';
import UtilService from '@/services/utilService';

import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        teamRosterItems: {
            type: Array,
            required: true
        },
        varietyRosterItems: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        cropLocationDayVarietyRoster: {
            type: Object,
            require: true
        }
    },
    components: {
        EditTableCell
    },
    watch: {
        dialog() {
            // if(this.dialog) {
            //     console.log('oepn');
            //     console.log(this.$refs);
            //     if(this.$refs['dialog']) {
            //         this.$refs['dialog'].focus();
            //     }
            // }
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Location',
                    value: 'LocationName',
                    class:"text-xs-center info lighten-4"
                },
                {   text: 'Variety', 
                    value: 'VarietyName',
                    class:"text-xs-center info lighten-4" },
                {   text: 'Team',
                    value: 'TeamName',
                    class:"text-xs-center info lighten-4" },
                {   text: 'Volume',
                    value: 'Volume', 
                    width: 150,
                    class:"text-xs-center info lighten-4" }
            ],
            varietyHeaders: [
                  {
                    text: '',
                    value: '',
                    class:"text-xs-center info lighten-4",
                    sortable: false
                },
                {   text: 'Variety', 
                    value: 'VarietyName',
                    class:"text-xs-center info lighten-4" },
                {   text: '',
                    value: '',
                    class:"text-xs-center info lighten-4",
                    sortable: false },
                {   text: 'Volume',
                    value: 'Volume', 
                    width: 150,
                    class:"text-xs-center info lighten-4" }
            ],
            pagination: {
                sortBy: 'TeamName',
                rowsPerPage: -1
            },
            teamEditMode: [],
            teamLoading: [],
            varietyEditMode: [],
            varietyLoading: [],
            validateRosterValue(v){
                if(v == null || !v.match(/^[0-9]{1,5}$/)){
                    return "Please enter a number in the form XXXXX";
                }
                return false;
            }
        }
    },
    computed: {
        ...mapGetters("RosterStore", [            
            "uom"
        ]),
        title() {
            var title = `Mix Volume Allocation`;
            if(this.cropLocationDayVarietyRoster) {
                title = title + ' - ' + this.cropLocationDayVarietyRoster.LocationName + '(' +moment(this.cropLocationDayVarietyRoster.Date).format('DD/MM/YYYY') +')'
            } 
            return title;
        }
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        save() {
            if(this.teamRosterItems.length == 0) {
                this.$emit("saveVariety", this.varietyRosterItems);
            } else {
                this.$emit("saveTeam", this.teamRosterItems);
            }
        },
        openTeamEdit(index) {
            if(this.teamEditMode.indexOf(index) < 0){
                this.teamEditMode.push(index);
            }
        },
        isTeamEditing(index) {
            return this.teamEditMode.indexOf(index) >= 0
        },      
        modifyTeamRosterValue(index, item, event){
            var newValue = event.value;
            var isEnter = event.isEnter;
            if(this.teamLoading.indexOf(index) < 0){
                this.teamLoading.push(index);
            }

            item.Volume = newValue;
            this.reCalculateVarietyRosters();
            if(this.teamLoading.indexOf(index) >= 0){
                this.teamLoading.splice(this.teamLoading.indexOf(index), 1);
            }
            this.closeTeamEdit(index, isEnter);
        },
        closeTeamEdit(index, isEnter){
            if(this.teamEditMode.indexOf(index) >= 0){
                this.teamEditMode.splice(this.teamEditMode.indexOf(index), 1);
            }
            if(isEnter) {
                this.focusNextRefElement('t'+index);
            }
        },
        openVarietyEdit(index) {
            if(this.varietyEditMode.indexOf(index) < 0){
                this.varietyEditMode.push(index);
            }
        },
        isVarietyEditing(index) {
            return this.varietyEditMode.indexOf(index) >= 0;
        },
        modifyVarietyRosterValue(index, item, event){
            var newValue = event.value;
            var isEnter = event.isEnter;
            if(this.varietyLoading.indexOf(index) < 0){
                this.varietyLoading.push(index);
            }
            item.Volume = newValue;
            this.reCalculateTeamRosters();
            if(this.varietyLoading.indexOf(index) >= 0){
                this.varietyLoading.splice(this.varietyLoading.indexOf(index), 1);
            }
            this.closeVarietyEdit(index, isEnter);
        },
        closeVarietyEdit(index, isEnter){
            if(this.varietyEditMode.indexOf(index) >= 0){
                this.varietyEditMode.splice(this.varietyEditMode.indexOf(index), 1);
            }
            if(isEnter) {
                this.focusNextRefElement('v'+index);
            }
        },
        focusNextRefElement(index) {
            UtilService.focusNextRefElement(this.$refs, index); 
        },
        reCalculateTeamRosters() {
             this.varietyRosterItems.forEach(v=> {
                var oldVolume = null;
                this.teamRosterItems.filter(t=> t.VarietyID == v.VarietyID)
                .forEach(teamRosterItem => {
                     if(teamRosterItem.Volume != null) {
                        if(oldVolume == null) {
                            return oldVolume = parseInt(teamRosterItem.Volume);
                        } else {
                            oldVolume = oldVolume + parseInt(teamRosterItem.Volume);
                        }
                    }
                });
                var volumeDiff = v.Volume - oldVolume;
                var targetTotal = v.Volume;
                var currentTotal = 0;
                if(v.Volume != oldVolume) {
                    var filteredTeamRosterItems = this.teamRosterItems.filter(t=> t.VarietyID == v.VarietyID);
                    var allNA = filteredTeamRosterItems.length == filteredTeamRosterItems.filter(r=> r.Volume == null).length;
                    filteredTeamRosterItems.forEach(teamRosterItem => {
                        if(oldVolume == 0 || allNA) {
                            teamRosterItem.Volume = parseInt(v.Volume / filteredTeamRosterItems.length);
                        } else {
                            teamRosterItem.Volume = parseInt((teamRosterItem.Volume == null ? 0 : teamRosterItem.Volume) * (1 + (volumeDiff / oldVolume)));
                        }
                        currentTotal= currentTotal + teamRosterItem.Volume;
                    })
                    if(targetTotal != currentTotal) {
                        var newValues = filteredTeamRosterItems.map(r=> r.Volume);
                        var allocatedValues = RosterUtilService.distrubuteValueEvenly(targetTotal, currentTotal, newValues);
                        filteredTeamRosterItems.forEach((t, i) => {
                            t.Volume = allocatedValues[i];
                        });
                    }
                }

            })
        },
        reCalculateVarietyRosters() {
            this.varietyRosterItems.forEach(v=> {
                var volume = null;
                this.teamRosterItems.filter(t=> t.VarietyID == v.VarietyID)
                .forEach(teamRosterItem => {
                     if(teamRosterItem.Volume != null) {
                        if(volume == null) {
                            return volume = parseInt(teamRosterItem.Volume);
                        } else {
                            volume = volume + parseInt(teamRosterItem.Volume);
                        }
                    }
                });
                v.Volume = volume;

            })
        },
        keydown() {
            if(this.dialog) {
                this.save();
            }
        }
    }
    
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
.edit-table-cell input::-webkit-outer-spin-button,
.edit-table-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.edit-table-cell input[type=number] {
  -moz-appearance: textfield;
}

</style>
